export default __webpack_public_path__ + "static/media/portrait.dc6c5741.png";